export default {
  getData(state) {
    return state.data;
  },
  getPlatformFeatures(state) {
    return state.platformFeatures;
  },
  getVendors(state) {
    return state.vendors;
  },
  getVendorProducts(state) {
    return state.vendorProducts;
  },

};
